import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const BreadCrumbList = _ref => {
  var _claimGroup$company;
  let {
    claimGroup,
    items
  } = _ref;
  const {
    t
  } = useTranslation();
  const user = useSelector(state => state.auth.user);
  const itemList = {
    home: {
      link: '',
      text: 'home'
    },
    companies: {
      link: "/".concat(user.account_type, "/companies"),
      text: 'companies'
    },
    company: {
      link: "/".concat(user.account_type, "/companies/").concat(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.company_id, "/master"),
      text: "".concat(claimGroup === null || claimGroup === void 0 ? void 0 : claimGroup.company.name)
    },
    bsfz: {
      link: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/project_overview"),
      text: "BSFZ ".concat(claimGroup === null || claimGroup === void 0 || (_claimGroup$company = claimGroup.company) === null || _claimGroup$company === void 0 ? void 0 : _claimGroup$company.name)
    },
    bsfz_project_overview: {
      link: "/".concat(user.account_type, "/claim_groups/").concat(claimGroup.id, "/project_overview"),
      text: 'bsfz_project_overview'
    },
    edit_claim_info: {
      link: '',
      text: 'edit_claim_info'
    },
    engagement_team: {
      link: '',
      text: 'engagement_team'
    }
  };
  return items.map((item, index, array) => {
    var _itemList$item;
    const isLast = index === array.length - 1;
    const itemText = typeof item === 'string' ? itemList[item].text : item.text;
    const itemLink = typeof item === 'string' ? (_itemList$item = itemList[item]) === null || _itemList$item === void 0 ? void 0 : _itemList$item.link : item.link;
    return /*#__PURE__*/React.createElement(Breadcrumb.Item, {
      linkAs: Link,
      linkProps: {
        to: itemLink
      },
      active: isLast,
      key: itemText + '_key'
    }, t(itemText));
  });
};
export default BreadCrumbList;